module.exports = __webpack_public_path__ + "static/img/AS.9e06f3d6.png";